import { useNavigate, useSearch } from '@tanstack/react-router';

import { Text } from '../../cdl/Text/Text';
import { OverviewSupplierCompanySelect } from '../../common/form-elements/CompanySelect/OverviewSupplierCompanySelect';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { useRole } from '../../common/hooks/useRole';
import { Page } from '../../common/Page/Page';
import { PageGrid } from '../../common/PageGrid';
import { DebouncedSearchTextInput } from '../../common/Search/DebouncedSearchTextInput/DebouncedSearchTextInput';
import { Box } from '../../common/ui/Box';
import { SupplierRfqOverviewTable } from '../../rfq/overview/components/SupplierRfqOverviewTable';

import { OfferOverviewSortSelect } from './OfferOverviewSortSelect';

export const SupplierOfferOverviewPage = () => {
    const title = translate('order.overviewPageTitle');
    useDocumentTitle(title);

    const role = useRole();

    const search = useSearch({ from: '/_app/offers' });
    const navigate = useNavigate({ from: '/offers' });

    return (
        <Page>
            <PageGrid>
                <Text variant="headline" as="h1">
                    {title}
                </Text>

                <Box display="flex" justifyContent="space-between" columnGap={8}>
                    <Box display="flex" columnGap={8}>
                        <Box minWidth="250px">
                            <DebouncedSearchTextInput
                                placeholder={translate('offer.searchInputPlaceholder')}
                                value={search.searchQuery ?? ''}
                                onChange={(searchQuery) => {
                                    navigate({
                                        search: (previousSearch) => ({
                                            ...previousSearch,
                                            searchQuery,
                                            page: 0,
                                        }),
                                    });
                                }}
                            />
                        </Box>

                        {!role.isOneCompanyUser() ? (
                            <OverviewSupplierCompanySelect
                                value={search.supplierIds ?? []}
                                onChange={(supplierIds) => {
                                    navigate({
                                        search: (previousSearch) => ({
                                            ...previousSearch,
                                            supplierIds,
                                            page: 0,
                                        }),
                                    });
                                }}
                            />
                        ) : null}
                    </Box>

                    <Box minWidth="250px">
                        <OfferOverviewSortSelect
                            onChange={(sortValue) => {
                                navigate({
                                    search: (previousSearch) => ({
                                        ...previousSearch,
                                        sortValue,
                                        page: 0,
                                    }),
                                });
                            }}
                            value={search.sortValue}
                        />
                    </Box>
                </Box>

                <SupplierRfqOverviewTable />
            </PageGrid>
        </Page>
    );
};
